"use client";

import { usePathname } from "next/navigation";
import { useAutoPreload } from "@/lib/hooks/google-drive/use-google-drive-preloader";

/**
 * Route prefixes where Google Drive folders/documents actually surface in the
 * UI (company/contact/deal detail, MSP docs, client workspace). The Drive
 * preloader only warms its cache on these routes — previously it ran on EVERY
 * page for every authenticated user (including chat, reports, tickets, time
 * entries, invoices, admin, and the client portal), firing Drive API calls
 * that most pages never use.
 */
const DRIVE_ROUTE_PREFIXES = [
  "/companies",
  "/contacts",
  "/deals",
  "/crm",
  "/clients",
  "/msp-docs",
];

/**
 * Invisible component that initializes Google Drive preloading.
 * Placed high in the tree (layout.tsx) but scoped to Drive-relevant routes so
 * the preload only runs where the cache it warms is actually consumed.
 */
export function DrivePreloadInitializer() {
  const pathname = usePathname();
  const onDriveRoute = DRIVE_ROUTE_PREFIXES.some(
    (prefix) => pathname === prefix || pathname?.startsWith(`${prefix}/`)
  );

  // Start preloading 3s after auth, but only on Drive-relevant routes.
  useAutoPreload(3000, onDriveRoute);

  // This component renders nothing - it's just for the side effect
  return null;
}
